import { Component, Input } from "@angular/core";

/**
 * Renders a chart returned by the copilot's chart tools
 * (MakeConvergenceChart / MakeCostChart). The backend sends a ready-to-use
 * ECharts `option` object plus optional comparability notes; we just bind it.
 */
@Component({
  selector: "app-chart-message",
  templateUrl: "./chart-message.component.html",
  styleUrls: ["./chart-message.component.less"],
  standalone: false,
})
export class ChartMessageComponent {
  @Input() content: any;

  get option(): any {
    return this.content?.echarts_option ?? null;
  }

  get title(): string {
    return this.content?.title ?? "Chart";
  }

  get notes(): string[] {
    return this.content?.comparability_notes ?? [];
  }

  get isEmpty(): boolean {
    return !!this.content?.empty || !this.option;
  }
}
